<template>
  <div>
    <img src="../assets/probanner.jpg" class="img-fluid w-100" alt="banner02">
<!--    <div class="positions">-->
<!--      <div class="width1200">-->
<!--        <router-link to="/" class="underline">首页</router-link> &gt; 产品展示-->
<!--      </div>-->
<!--    </div>-->
    <section class="feature-area">
      <div class="mbx">
        <div class="container">
          <div class="row">
            <div class="col-lg-9">
              <div class="nytit pull-left">产品展示</div>
              <menu class="menu pull-left" id="menu">
<!--                <div class="pull-left paddingleft15"><a href="javascript:void(0);" class="underline text66" :class="{'cur':nav_status_1}" @click="changeTab(0)">企业动态</a></div>-->
<!--                <div class="pull-left paddingleft15"><a href="javascript:void(0);" class="underline text66" :class="{'cur':nav_status_2}" @click="changeTab(1)">代理品牌动态</a></div>-->
<!--                <div class="pull-left paddingleft15"><a href="javascript:void(0);" class="underline text66" :class="{'cur':nav_status_3}" @click="changeTab(2)">行业资讯</a></div>-->
              </menu>
            </div>
            <div class="col-lg-3">
              <div class="mbxwrap">
                <router-link to="/" class="underline">首页</router-link> <span>/</span>
                <em>产品展示</em>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

    <section class="feature-area" style="padding-top: 20px; padding-bottom: 20px">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 contleft">
            <div class="wrapper"  style="min-width: 150px">
              <!-- Sidebar -->
              <nav id="sidebar">
                <div class="sidebar-header">
                  <h2 class="leftTitle">产品展示</h2>
                </div>

                <div class="leftNav">
                  <ul class="list-unstyled components" style="min-width: 150px">
                    <li v-for="(list,index) in menuList">
                      <div v-if="list.children != undefined && list.children != null && list.children != '' ">
                        <a :href="'#submenu'+index" :key="index" data-toggle="collapse" :id="'a'+index" aria-expanded="false" class="dropdown-toggle" @click="changeIndex(index)">{{list.menuName}}</a>
                        <ul class="collapse list-unstyled" :id="'submenu'+index">
                          <li v-for="(sublist, subindex) in list.children">
                            <div v-if="sublist.children != undefined && sublist.children != null && sublist.children != ''">
                              <a :href="'#childmenu'+subindex" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle leftNavCur"  @click="changeIndex2(subindex)"> &nbsp;&nbsp;{{sublist.menuName}}</a>
                              <ul class="collapse list-unstyled sub" :id="'childmenu'+subindex">
                                <li v-for="(childlist, childindex) in sublist.children">
                                  <a href="javascript:void(0);" class="leftNavCur2 secondmenu p2" :key="subindex" @click="getProducts(childlist.id, childlist.menuName, 1)"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- {{childlist.menuName}}</a>
                                </li>
                              </ul>
                            </div>
                            <div v-else>
                              <a href="javascript:void(0);" class="leftNavCur2 p2" :key="subindex" @click="getProducts(sublist.id, sublist.menuName, 1)"> - {{sublist.menuName}}</a>
                            </div>
                          </li>
                        </ul>
                      </div>

                    </li>
                  </ul>
                </div>
              </nav>

            </div>
          </div>

          <!--contleft 产品展示-->
          <div class="col-lg-9 contright">
            <h2 class="rightTitle">{{titleName}}</h2>
            <div class="Article">
              <div class="row" style="width: 90%; margin: auto; ">
                <div class="col-lg-4 col-md-6 section-padding4 " v-for="(list,index) in productList">
                  <div class="card div1 big-box" style="background-color: #F5F5F5" :key="index" @click="toProductDetails(list)">
                    <div>
                      <img :src="list.path" class="card-img-top aspect-ratio-16-9" alt="" :title="list.name">
                    </div>
                    <div class="card-body " style="border-top: 1px solid lightgrey">
                      <p class="card-text p2 " :title="list.name">{{list.name}}</p>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <Pagination v-if="total != 0" style="float: right;"
              :page-no="pageNo"
              :page-size="pageSize"
              :total="total"
              :continues="5"
              @getPageNo="getPageNo"
            ></Pagination>
          </div><!--contright/-->

        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
  export default {
    data(){
      return{
        pageLists: [
          {
            title: '首页',
            link: '/'
          },
          {
            title: '公司简介',
            link: 'introduction'
          },
          {
            title: '产品展示',
            link: 'news'
          },
        ],

        navLists: JSON.parse(this.$_storage.getLocalStore("navLists")),
        productList: [],
        menuList: [],
        titleName: "产品展示",
        pageSize: 9,
        pageNo: 1,
        total: 0,
        parentId: "",
        menuIndex: -1,
        menuSubIndex: -1,
      }
    },
    components: {
      Pagination,
    },
    methods: {
      // 获取菜单
      getMenu() {
        const vm = this;

        vm.$_axios({
          method: 'post',
          url: '/mapis/menu/getMenu',
          needLogin: false,
          params: {
            type: 1
          },
        }).then((response) => {
          if (response.status === 200) {
            const responseData = response.data.data;
            vm.menuList = responseData;
            console.log("vm.menuList[0]"+ vm.menuList[0])
            if(vm.menuList[0] != undefined && vm.menuList[0] != null && vm.menuList[0] != ''){
              vm.getFirstTypeProduct(vm.menuList[0]);
              // vm.changeIndex3(1);
            }
          }
        });
      },

      // 获取产品数据
      getProducts(id, name, pageNo) {
        const vm = this;
        vm.titleName = name;
        vm.parentId = id;
        vm.pageNo = pageNo;
        vm.$_axios({
          method: 'post',
          url: '/mapis/product/getProducts',
          data: {
            parentId: vm.parentId,
            pageNo: vm.pageNo,
            pageSize: vm.pageSize
          },
          needLogin: false,
        }).then((response) => {
          if (response.status === 200) {
            const responseData = response.data.data;
            vm.productList = responseData.productDtoList;
            vm.total = responseData.total;
          }
        });
      },
      changeIndex(index){
        const vm = this;
        //onclick of dropdown
        if(index != this.menuIndex){
            //change attr of other..
            $(".dropdown-toggle").not(this).attr("aria-expanded", "false")
            //addclass of other..
            $(".dropdown-toggle").not(this).addClass("collapsed")
            //remove show class from others
            $(".list-unstyled").not($(this).next("ul")).removeClass("show")
          vm.menuIndex = index;
        }
      },
      changeIndex2(index){
        const vm = this;
        //onclick of dropdown
        if(index != this.menuSubIndex){
        //change attr of other..
        $(".leftNavCur").not(this).attr("aria-expanded", "false")
        //addclass of other..
        $(".leftNavCur").not(this).addClass("collapsed")
        //remove show class from others
        $(".sub").not($(this).next("ul")).removeClass("show")
        vm.menuSubIndex = index;
        }
      },
      changeIndex3(index){
        console.log("changeIndex3")
        const vm = this;
        //onclick of dropdown
        this.menuIndex = 0;
        $("#submenu0").addClass("aaa");
        $(".dropdown-toggle").addClass("aaa")

      },

      getFirstTypeProduct(menu){
        if(menu.children != undefined && menu.children != null && menu.children != ''){
          this.getFirstTypeProduct(menu.children[0]);
        }else{
          this.getProducts(menu.id, menu.menuName, 1);
        }
      },

      getPageNo(pageNo) {
        const vm = this;
        vm.pageNo = pageNo;
        vm.getProducts(vm.parentId, vm.titleName, vm.pageNo);
      },

      // 获取产品详情
      getProductDetails(id) {
        const vm = this;
        vm.$_axios({
          method: 'post',
          url: '/mapis/product/getProductDetails',
          params: {
            id: id
          },
          needLogin: false,
        }).then((response) => {
          if (response.status === 200) {
            const responseData = response.data.data;
            vm.productList = responseData;
            vm.$router.push({name:'products',query:{parentId:id, s:Math.random()}});
          }
        });
      },

      //获取产品详情
      toProductDetails(product){
        const vm = this;
        if(product.decr == null){
          this.$alert("暂无详细介绍");
          return;
        }

        vm.$_storage.setLocalStore('product',product);
        vm.$router.push({name:'productDetails'});
      },


    },
    created() {
      let vm = this;
      vm.getMenu();
      // vm.getProducts();
      this.$router.afterEach((to, from, next) => {
        window.scrollTo(0, 0)
      })

    },
    mounted() {
      let vm = this;

    }
  };




</script>




// WEBPACK FOOTER //
// Products.vue?769a8647